const ringoPhoneMutations = (selector) => {
    let observer = new MutationObserver(mutations => {
        for(let mutation of mutations) {

            let changed = mutation.target.innerText.replace('(', '').replace(')', '');

            if(mutation.target.innerText !== changed) {
                mutation.target.innerText = changed;
            }

        }
    });


    document.querySelectorAll(selector).forEach(function(node) {
        observer.observe(node, {childList: true, subtree: true})
    })
};

export default ringoPhoneMutations;